import React from 'react';
import { PATH } from '../../../../../../constants';
import './DetailPhoto.css';
import { TEXT } from '../../../../../../content';

const DetailPhoto = props => {
  const { detailId } = props;
  return (
    <img
      className="detail-image"
      src={`${PATH.PHOTO}${detailId}.jpg`}
      alt={TEXT.PHOTO}
    />
  );
};

export default DetailPhoto;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/DetailPhoto/DetailPhoto.js